import { z } from 'zod';

export const UploadStepSchema = z.discriminatedUnion('tipo', [
  z.object({
    tipo: z.literal('archivio-singolo'),
    label: z.string().optional(),
  }),
  z.object({
    tipo: z.literal('multi-zip'),
    expectedPrefixes: z.array(z.string()).min(1).optional(),
    label: z.string().optional(),
  }),
  z.object({
    tipo: z.literal('file-singolo'),
    label: z.string().optional(),
  }),
  z.object({
    tipo: z.literal('select-periodo'),
    range: z.object({ annoMin: z.number(), annoMax: z.number() }).optional(),
    label: z.string().optional(),
  }),
  z.object({
    tipo: z.literal('sindacati-accessori'),
    label: z.string().optional(),
  }),
]);
export type UploadStep = z.infer<typeof UploadStepSchema>;

export const AccessoryInputSpecSchema = z.object({
  label: z.string(),
  acceptTypes: z.array(z.string()).min(1),
  required: z.boolean(),
});
export type AccessoryInputSpec = z.infer<typeof AccessoryInputSpecSchema>;

export const UploadUiSpecSchema = z.object({
  steps: z.array(UploadStepSchema).min(1),
  acceptTypes: z.array(z.string()).min(1),
  multipleFiles: z.boolean(),
  expectedPrefixes: z.array(z.string()).optional(),
  helpText: z.string().optional(),
  accessoryInputs: z.record(z.string(), AccessoryInputSpecSchema).optional(),
  customComponent: z.string().optional(),
});
export type UploadUiSpec = z.infer<typeof UploadUiSpecSchema>;
